<template>
  <div class="container">
    <v-card>
      <div v-show="!isHelpOpen" class="invalid-browser-alerte">
        <v-btn
          class="right-align material-icons invalid-browser-btn"
          icon
          @click="isHelpOpen = !isHelpOpen"
        >
          <v-icon color="secondary"> mdi-information </v-icon>
        </v-btn>
        <h1 class="mb-8">
          {{ appName }}
        </h1>
        <p>
          <b
            >Cette version de votre navigateur ne permet pas un usage optimal de
            votre application.</b
          >
        </p>
        <p>
          Pour vous proposer un service de meilleure qualité, nous vous invitons
          à vous servir des navigateurs web suffisamment récents :
        </p>
        <p>
          Chrome (téléchargeable
          <a
            href="https://www.google.fr/chrome/"
            target="_blank"
            rel="noopener noreferrer"
            >ici</a
          >) ou Mozilla Firefox (téléchargeable
          <a
            href="https://www.mozilla.org/fr/firefox/new/"
            target="_blank"
            rel="noopener noreferrer"
            >ici</a
          >).
        </p>
        <p>
          Notre objectif est de vous faire profiter des meilleures conditions
          possibles d’utilisation !
        </p>
      </div>
      <div v-show="isHelpOpen" class="invalid-browser-help">
        <v-btn
          class="right-align material-icons invalid-browser-btn"
          icon
          @click="isHelpOpen = !isHelpOpen"
        >
          <v-icon color="secondary"> mdi-close </v-icon>
        </v-btn>
        <h1 class="mb-8">
          {{ appName }}
        </h1>
        <p>
          Les navigateurs sont les logiciels qui vous permettent de consulter le
          Web depuis votre PC, smartphone, ou encore, tablette. Ces navigateurs
          bénéficient régulièrement de nouvelles versions permettant d'améliorer
          leurs performances, ainsi que leur sécurité. Quel que soit votre
          navigateur internet actuel, il est fortement recommandé que vous
          disposiez de sa dernière version. Vous bénéficierez ainsi des
          fonctionnalités du web les plus récentes ! De plus les mises à jour
          sont simples et gratuites.
        </p>
        <p>Nous vous invitons à utiliser les navigateurs suivants :</p>
        <ul>
          <li>
            Chrome (téléchargeable
            <a
              href="https://www.google.fr/chrome/"
              target="_blank"
              rel="noopener noreferrer"
              >ici</a
            >), navigateur produit par Google, peut être installé indifféremment
            sur un PC ou un téléphone mobile fonctionnant sous Windows, MacOS,
            Linux, Android, etc.
          </li>
          <li>
            Firefox (téléchargeable
            <a
              href="https://www.mozilla.org/fr/firefox/new/"
              target="_blank"
              rel="noopener noreferrer"
              >ici</a
            >
            ), navigateur logiciel libre, distribué par la fondation Mozilla,
            organisation sans but lucratif. Il peut être installé indifféremment
            sur un PC ou un téléphone mobile fonctionnant sous Windows, MacOS,
            Linux, Android, etc.
          </li>
          <li>
            Safari, navigateur d’Apple, installé par défaut sur les ordinateurs
            Mac et Iphone.
          </li>
        </ul>
      </div>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export default {
  name: 'CheckBrowser',
  data () {
    return {
      isHelpOpen: false
    };
  },
  computed: {
    appName () {
      return window.PROPERTIES.get('app.name');
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .v-card {
    // width: 800px;
    padding: 30px;
  }
  position: relative;
}
.invalid-browser-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  background-color: #ffffff;
}

.invalid-browser-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  padding-left: 2px;
  color: #ac6d23;
  transition: all 0.3s linear;
  font-size: 22px;
  vertical-align: bottom;
  cursor: pointer;
}

img {
  width: 40%;
}

ul:not(.browser-default) {
  padding-left: 40px;
}

ul:not(.browser-default) > li {
  margin-left: 12px;
  text-align: left;
  padding: 12px;
  list-style-type: initial;
}

@media screen and (max-width: 600px) {
  img {
    width: 60%;
  }

  ul:not(.browser-default) {
    padding-left: 14px;
  }

  .invalid-browser-alerte,
  .invalid-browser-help {
    margin: 10px;
    font-size: 10px;
  }
}
</style>
